import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { MARK_TEXT_COLOR } from './defaults';
import { renderLeafTextColor, renderLeafTextColorReadOnly } from './rederLeafTextColor';
import { TextColorMarkPluginOptions } from './types';

const deserializeTextColor = (el) => {
  if (
    el &&
    el.nodeName === 'SPAN' &&
    (el.classList?.contains('slate-text-color') || el.style.color)
  ) {
    const nodeColorKey =
      typeof el?.getAttribute === 'function' && el.getAttribute('data-color-key');
    return { [MARK_TEXT_COLOR]: { colorKey: nodeColorKey } };
  }
  return undefined;
};

export const TextColorPlugin = (options?: TextColorMarkPluginOptions): SlatePlugin => ({
  renderLeaf: renderLeafTextColor(options),
  deserialize: {
    leaf: [
      {
        type: 'text-color',
        deserialize: deserializeTextColor,
      },
    ],
  },
});

export const TextColorReadOnlyPlugin = (options?: TextColorMarkPluginOptions): SlatePlugin => ({
  renderLeaf: renderLeafTextColorReadOnly(options),
});
